import { createFileRoute } from "@tanstack/react-router";

import { ProfileRouteComponent } from "./-profile-component";

export const Route = createFileRoute("/dashboard/settings/profile")({
  component: ProfileRouteComponent,
});
